import { AxiosRequestConfig, AxiosResponse, AxiosInstance } from "axios"

import { ResponseData } from "../common"

export interface FavoriteListByPropertyIdParams {
  propertyId: string
}

export interface AddFavoriteListByPropertyIdRequest
  extends Partial<AxiosRequestConfig> {
  params: FavoriteListByPropertyIdParams
}

export interface AddFavouritesListResponseDataData {
  favouriteId: number
  message: string
  name: string
  count: number
}

export interface AddFavouritesListResponseData extends ResponseData {
  data: AddFavouritesListResponseDataData
}
export interface AddFavouritesListResponse extends AxiosResponse {
  data: AddFavouritesListResponseData
}

export function createFavoriteListByPropertyIdApi(
  { params }: AddFavoriteListByPropertyIdRequest,
  axiosInstance: AxiosInstance,
): Promise<AddFavouritesListResponse> {
  const url = `/user/favouritelist/favorite-list-by-property-id`

  return axiosInstance({
    params,
    method: "post",
    url,
  }) as Promise<AddFavouritesListResponse>
}
